import { DeceasedPersonComponent } from './deceased-person/deceased-person.component';

export const DeceasedModule = [DeceasedPersonComponent];
